import Typography from "@mui/material/Typography";
import { LabelWithControl } from "components/common/LabelControl";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDestinationName } from "./Utility";
import { Tooltip } from "@mui/material";

export const CommonHeader = ({
  data,
  handball,
  handleHandballToggle,
  rounding,
  handleRoundingToggle,
  overseas,
  handleOverseasToggle,
}) => {

  const { locationResponse } = useSelector((state) => state.locations);
  const [headerData, setHeaderData] = useState(data);

  const getCategorysFromItems = (items) => {
    const categorys = [];
    if(items && items.length > 0) {
      items.forEach((item) => {
        if(!categorys.includes(item.category)) {
          categorys.push(item.category);
        }
      });
    }
    return categorys.join(', ');
  }

  useEffect(() => {
    if(data){
      setHeaderData({
        ...data,
        category: data.category ? data.category : getCategorysFromItems(data.items),
        shipToLocationName: data.shipToLocationName ? data.shipToLocationName : getDestinationName(locationResponse, data.shipToLocationId)
      });
    }
  },[data, locationResponse]);

  return (
    <div className="poHeaderStyling">
      <Grid sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <Grid container spacing={2} sx={{ "& > *": { flex: 1 } }}>
          <Grid item xs={12} sm={6} md={2}>
            <LabelWithControl label="Supplier" labelId="suplier">
              <Typography id="supplier">
                {headerData?.supplierId}{headerData?.supplierName ? ` ${headerData.supplierName}` : ""}
              </Typography>
            </LabelWithControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <LabelWithControl label="Destination" labelId="destination">
              <Typography id="destination">
                {headerData?.shipToLocationId} {headerData?.shipToLocationName}
              </Typography>
            </LabelWithControl>
          </Grid>
          <Grid item xs={12} sm={6} md={1.5}  className='commonHeaderCategory'>
            <LabelWithControl label="Category" labelId="category">
               <Tooltip title={headerData?.category}>
                <Typography id="category">{headerData?.category}</Typography>
               </Tooltip>
            </LabelWithControl>
          </Grid>
          <Grid item xs={12} sm={6} md={1.5}>
            <LabelWithControl
              label="PO Delivery Method"
              labelId="deliveryMethod"
            >
              <Typography id="deliveryMethod">{headerData?.deliveryMethod || "NA"}</Typography>
            </LabelWithControl>
          </Grid>
          <Grid item xs={12} sm={6} md={1.5}>
            <LabelWithControl
              label="Pallets per Wagon"
              labelId="palletPerWagon"
            >
              <Typography id="palletPerWagon">{headerData?.palletPerWagon}</Typography>
            </LabelWithControl>
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <FormControlLabel
              control={
                <Switch
                  checked={handball}
                  onChange={handleHandballToggle}
                  color="primary"
                />
              }
              className="switchLabelText"
              label="Handball"
              labelPlacement="start"
              style={{ fontSize: "11px", fontWeight: "bold" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <FormControlLabel
              control={
                <Switch
                  checked={overseas}
                  onChange={handleOverseasToggle}
                  color="primary"
                />
              }
              className="switchLabelText"
              label="Import"
              labelPlacement="start"
              style={{ fontSize: "11px", fontWeight: "bold" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <FormControlLabel
              control={
                <Switch
                  checked={rounding}
                  onChange={handleRoundingToggle}
                  color="primary"
                />
              }
              className="switchLabelText"
              label="Rounding"
              labelPlacement="start"
              style={{ fontSize: "11px", fontWeight: "bold" }}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
